// extracted by mini-css-extract-plugin
export default {"addToCartControl":"G1-z","giftCard":"H1-z","btnContainer":"I1-z","cartButton":"J1-z","disabled":"K1-z"};